<template>
  <div class="row">
    <div class="col-12">
      <b-form-fieldset>
        <select class="form-control" disabled v-model="isian.kdkantor">
          <option value="020400">020400 - KPU BC Tipe B Batam</option>
        </select>
      </b-form-fieldset>
      <b-card header="<i class='fa fa-align-justify'></i> Pengajuan Izin">
        <div slot="header">
          <strong>Form Header Perijinan</strong>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <b-card>
              <div slot="header">
                <strong>Identitas Perijinan</strong>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-fieldset label="Jenis Identitas">
                    <select :disabled="disab" class="form-control" v-model="isian.perjnid" title="Identitas perusahaan">
                      <option v-for="id in identitas" :value="id.kd_id" :key="id.kd_id">{{ id.URAIAN }}</option>
                    </select>
                  </b-form-fieldset>
                </div>
                <div class="col-md-8">
                  <b-form-fieldset label="No Identitas">
                    <b-form-input title="Nomor identitas perusahaan" name="No Identitas" v-validate="'required'" :disabled="disab" v-model="isian.perid" type="text" placeholder="No Identitas"></b-form-input>
                    <small class="text-danger" v-show="errors.has('No Identitas')">
                      {{ errors.first('No Identitas') }}
                    </small>
                  </b-form-fieldset>
                </div>
              </div>
              <b-form-fieldset label="Nama">
                <b-form-input title="Nama perusahaan" name="Nama" v-validate="'required'" :disabled="disab" type="text" placeholder="Nama" v-model="isian.pernama"></b-form-input>
                <small class="text-danger" v-show="errors.has('Nama')">
                  {{ errors.first('Nama') }}
                </small>
              </b-form-fieldset>
              <b-form-fieldset label="Alamat">
                <textarea title="Alamat perusahaan" name="Alamat" v-validate="'required'" rows="2" class="form-control" :disabled="disab" placeholder="Alamat" v-model="isian.peralamat"></textarea>
                <small class="text-danger" v-show="errors.has('Alamat')">
                   {{ errors.first('Alamat') }}
                </small>
              </b-form-fieldset>
              <div class="row">
                <div class="col-md-7">
                  <b-form-fieldset label="No Permohonan">
                    <b-form-input title="Nomor Permohonan Izin" name="No Permohonan" v-validate="'required'" v-model="isian.nopermohonan" type="text" placeholder="No Permohonan"></b-form-input>
                    <small class="text-danger" v-show="errors.has('No Permohonan')">
                      {{ errors.first('No Permohonan') }}
                    </small>
                  </b-form-fieldset>
                </div>
                <div class="col-md-5">
                  <b-form-fieldset label="Tgl Permohonan">
                    <b-form-input title="Tanggal Permohonan Izin" name="Tgl Permohonan" v-validate="'required'" v-model="isian.tglpermohonan" type="date"></b-form-input>
                    <small class="text-danger" v-show="errors.has('Tgl Permohonan')">
                      {{ errors.first('Tgl Permohonan') }}
                    </small>
                  </b-form-fieldset>
                </div>
              </div>
              <b-form-fieldset label="Jenis Perijinan">
                <select title="Jenis Permohonan Yang Diajukan" class="form-control" v-model="isian.jnperijinan">
                  <option value="">-- Pilih Jenis Perijinan --</option>
                  <option v-for="ijin in jnijin" :value="ijin.id_ijin" :key="ijin.id_ijin">{{ ijin.nama_ijin }}</option>
                </select>
              </b-form-fieldset>
              <b-form-fieldset label="Jenis Dokumen" v-if="isian.jnperijinan === 5">
                <select title="Jenis Dokumen Yang Diajukan" class="form-control" v-model="isian.jnsdok">
                  <option value="">Jenis Dokumen</option>
                  <option value=23>PPFTZ-01</option>
                  <option value=24>PPFTZ-02</option>
                  <option value=25>PPFTZ-03</option>
                </select>
              </b-form-fieldset>
              <b-form-fieldset label="Jenis Dokumen yang akan dibatalkan" v-if="isian.jnperijinan === 23">
                <select title="Jenis Dokumen Yang Diajukan" class="form-control" v-model="isian.jnsdok">
                  <option value="">Jenis Dokumen</option>
                  <option value=167>RKSP</option>
                  <option value=2>Inward Manifes</option>
                  <option value=3>Outward Manifes</option>
                </select>
              </b-form-fieldset>
            </b-card>
          </div>
          <div class="col-sm-6">
            <b-card>
              <div slot="header">
                <strong>Identitas Pemohon Izin</strong>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-fieldset label="Jenis Identitas">
                    <select class="form-control" v-model="isian.ppjkjnid" disabled>
                      <option v-for="id in identitas" :value="id.kd_id" :key="id.id_id">{{ id.URAIAN }}</option>
                    </select>
                  </b-form-fieldset>
                </div>
                <div class="col-md-8">
                  <b-form-fieldset label="No Identitas">
                    <b-form-input v-model="isian.ppjkid" :disabled="true" type="text" placeholder="No Identitas"></b-form-input>
                  </b-form-fieldset>
                </div>
              </div>
              <b-form-fieldset label="Nama">
                <b-form-input :disabled="true" type="text" v-model="isian.ppjknama"></b-form-input>
              </b-form-fieldset>
              <b-form-fieldset label="Alamat">
                <textarea rows="2" class="form-control" v-model="isian.ppjkalamat" disabled></textarea>
              </b-form-fieldset>
              <div class="row">
                <div class="col-6">
                  <b-form-fieldset label="No HP / Telepon">
                    <b-form-input title="Nomor HP Yang Dapat Dihubungi" name="No Telepon" v-validate="'required|max:15|min:3'" v-model="isian.notelp" type="text" placeholder="No HP / Telepon"></b-form-input>
                    <small class="text-danger" v-show="errors.has('No Telepon')">
                      {{ errors.first('No Telepon') }}
                    </small>
                  </b-form-fieldset>
                </div>
                <div class="col-6">
                  <b-form-fieldset label="Email">
                    <b-form-input title="Email Yang Dapat Dihubungi" name="Email" v-validate="'required|email'" v-model="isian.email" type="text" placeholder="Email"></b-form-input>
                    <small class="text-danger" v-show="errors.has('Email')">
                      {{ errors.first('Email') }}
                    </small>
                  </b-form-fieldset>
                </div>
              </div>
            </b-card>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <button title="Simpan Header Permohonan Izin" type="button" class="btn btn-primary px-4" @click="savePermohonan" name="button"><i class="fa fa-save"></i> Save</button>
            <router-link :to="'/pengajuanftz'" class="btn btn-secondary pull-right"><i class="fa fa-mail-reply"></i> Back</router-link>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import swal from 'sweetalert'
export default {
  data () {
    return {
      isian: {
        kdkantor: '020400',
        perjnid: '5',
        perid: '',
        pernama: '',
        peralamat: '',
        ppjkjnid: '',
        ppjkid: '',
        ppjknama: '',
        ppjkalamat: '',
        notelp: '',
        email: '',
        nopermohonan: '',
        tglpermohonan: '',
        jnperijinan: '',
        jnsdok: '',
        username: ''
      },
      disab: false,
      jnijin: [],
      identitas: [],
      tes: this.$store.getters['auth/user']['ppjk']
    }
  },
  created () {
    this.getJnIjin()
    this.getID()
    this.getPerusahaan()
  },
  methods: {
    getID () {
      this.$http.get('ref/kdid')
        .then(response => {
          this.identitas = response.data
        })
    },
    getJnIjin () {
      this.$http.get('ref/jnijin')
        .then(response => {
          this.jnijin = response.data
        })
    },
    getPerusahaan () {
      var data = {
        user: this.$store.getters['auth/user']['username']
      }
      var ppjk = this.$store.getters['auth/user']['ppjk']
      if (ppjk === 'Y' || ppjk === 'U') {
        this.disab = false
      } else {
        this.disab = true
      }
      this.$http.post('perusahaan', data)
        .then(response => {
          this.isian.ppjkjnid = response.data.kdid
          this.isian.ppjkid = response.data.idperusahaan
          this.isian.ppjknama = response.data.nmperusahaan
          this.isian.ppjkalamat = response.data.alperusahaan
          this.isian.notelp = response.data.notelp
          this.isian.email = response.data.email
          this.isian.username = response.data.username
          // if (ppjk !== 'Y') {
          this.isian.perjnid = response.data.kdid
          this.isian.perid = response.data.idperusahaan
          this.isian.pernama = response.data.nmperusahaan
          this.isian.peralamat = response.data.alperusahaan
          // }
        })
    },
    savePermohonan () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var permohonan = {
            idijin: this.isian.jnperijinan,
            nomohon: this.isian.nopermohonan,
            tglmohon: this.isian.tglpermohonan,
            kdid: this.isian.perjnid,
            idper: this.isian.perid,
            pernama: this.isian.pernama,
            peralamat: this.isian.peralamat,
            nohp: this.isian.notelp,
            email: this.isian.email,
            idrekam: this.isian.username,
            jnsdok: this.isian.jnsdok
          }
          this.$http.post('savepengajuan', permohonan)
            .then(response => {
              swal(response.data.status, response.data.message, response.data.status)
              if (response.data.status === 'success') {
                this.$router.push('/pengajuanftz')
              }
            })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/Pengajuan/AddHeaderFtz.vue?2b7f4f09